import React from 'react';

import { colorsPalette } from '../../theme';

const PathwayIcon = ({
  color = colorsPalette.white,
  secondaryColor = colorsPalette.blue,
  ...rest
}) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 47C9.98891 47 10.9556 47.2932 11.7779 47.8427C12.6001 48.3921 13.241 49.173 13.6194 50.0866C13.9978 51.0002 14.0969 52.0055 13.9039 52.9755C13.711 53.9454 13.2348 54.8363 12.5355 55.5355C11.8363 56.2348 10.9454 56.711 9.97545 56.9039C9.00555 57.0969 8.00021 56.9978 7.08658 56.6194C6.17295 56.241 5.39206 55.6001 4.84265 54.7779C4.29324 53.9556 4 52.9889 4 52C4.00062 50.6741 4.5276 49.4027 5.46515 48.4652C6.4027 47.5276 7.67411 47.0006 9 47ZM50 12C50 12.9889 50.2932 13.9556 50.8427 14.7779C51.3921 15.6001 52.173 16.241 53.0866 16.6194C54.0002 16.9978 55.0055 17.0969 55.9755 16.9039C56.9454 16.711 57.8363 16.2348 58.5355 15.5355C59.2348 14.8363 59.711 13.9454 59.9039 12.9755C60.0969 12.0055 59.9978 11.0002 59.6194 10.0866C59.241 9.17295 58.6001 8.39206 57.7779 7.84265C56.9556 7.29324 55.9889 7 55 7C53.6741 7.00062 52.4027 7.5276 51.4652 8.46515C50.5276 9.4027 50.0006 10.6741 50 12Z"
        fill={secondaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 48C6.79086 48 5 49.7909 5 52C5 54.2091 6.79086 56 9 56C11.2091 56 13 54.2091 13 52C13 49.7909 11.2091 48 9 48ZM3 52C3 48.6863 5.68629 46 9 46C12.3137 46 15 48.6863 15 52C15 55.3137 12.3137 58 9 58C5.68629 58 3 55.3137 3 52Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55 8C52.7909 8 51 9.79086 51 12C51 14.2091 52.7909 16 55 16C57.2091 16 59 14.2091 59 12C59 9.79086 57.2091 8 55 8ZM49 12C49 8.68629 51.6863 6 55 6C58.3137 6 61 8.68629 61 12C61 15.3137 58.3137 18 55 18C51.6863 18 49 15.3137 49 12Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9971 11L12 11L29 11C29.5523 11 30 11.4477 30 12C30 12.5523 29.5523 13 29 13H12.0016C11.2063 13.0027 10.4444 13.3198 9.88211 13.8821C9.31977 14.4444 9.00269 15.2064 9 16.0016V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V15.9971C7.00388 14.673 7.5316 13.4042 8.46789 12.4679C9.40419 11.5316 10.673 11.0039 11.9971 11Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 32C34 31.4477 34.4477 31 35 31H52.0072C53.3284 31.0095 54.5928 31.5386 55.5271 32.4729C56.4614 33.4072 56.9905 34.6716 57 35.9928L57 36L57 39C57 39.5523 56.5523 40 56 40C55.4477 40 55 39.5523 55 39V36.0038C54.9934 35.2092 54.6748 34.449 54.1129 33.8871C53.551 33.3252 52.7907 33.0066 51.9961 33H35C34.4477 33 34 32.5523 34 32Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 52C13 51.4477 13.4477 51 14 51H29C29.5523 51 30 51.4477 30 52C30 52.5523 29.5523 53 29 53H14C13.4477 53 13 52.5523 13 52Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56 44C56.5523 44 57 44.4477 57 45V48.0072C56.9905 49.3284 56.4614 50.5928 55.5271 51.5271C54.5928 52.4614 53.3284 52.9905 52.0072 53L52 53H35C34.4477 53 34 52.5523 34 52C34 51.4477 34.4477 51 35 51H51.9961C52.7907 50.9934 53.5509 50.6748 54.1129 50.1129C54.6748 49.551 54.9934 48.7908 55 47.9962V45C55 44.4477 55.4477 44 56 44Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00003 24C8.55231 24 9.00003 24.4477 9.00003 25V27.9961C9.00663 28.7907 9.32519 29.551 9.88713 30.1129C10.4491 30.6748 11.2093 30.9934 12.0039 31H29C29.5523 31 30 31.4477 30 32C30 32.5523 29.5523 33 29 33H11.9928C10.6716 32.9905 9.40719 32.4614 8.47292 31.5271C7.53865 30.5928 7.00957 29.3284 7.00005 28.0072L7 28L7.00003 25C7.00003 24.4477 7.44774 24 8.00003 24Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 12C34 11.4477 34.4477 11 35 11H50C50.5523 11 51 11.4477 51 12C51 12.5523 50.5523 13 50 13H35C34.4477 13 34 12.5523 34 12Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 20C6.89543 20 6 20.8954 6 22C6 23.1046 6.89543 24 8 24C9.10457 24 10 23.1046 10 22C10 20.8954 9.10457 20 8 20ZM4 22C4 19.7909 5.79086 18 8 18C10.2091 18 12 19.7909 12 22C12 24.2091 10.2091 26 8 26C5.79086 26 4 24.2091 4 22Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56 40C54.8954 40 54 40.8954 54 42C54 43.1046 54.8954 44 56 44C57.1046 44 58 43.1046 58 42C58 40.8954 57.1046 40 56 40ZM52 42C52 39.7909 53.7909 38 56 38C58.2091 38 60 39.7909 60 42C60 44.2091 58.2091 46 56 46C53.7909 46 52 44.2091 52 42Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 30C30.8954 30 30 30.8954 30 32C30 33.1046 30.8954 34 32 34C33.1046 34 34 33.1046 34 32C34 30.8954 33.1046 30 32 30ZM28 32C28 29.7909 29.7909 28 32 28C34.2091 28 36 29.7909 36 32C36 34.2091 34.2091 36 32 36C29.7909 36 28 34.2091 28 32Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 50C30.8954 50 30 50.8954 30 52C30 53.1046 30.8954 54 32 54C33.1046 54 34 53.1046 34 52C34 50.8954 33.1046 50 32 50ZM28 52C28 49.7909 29.7909 48 32 48C34.2091 48 36 49.7909 36 52C36 54.2091 34.2091 56 32 56C29.7909 56 28 54.2091 28 52Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 10C30.8954 10 30 10.8954 30 12C30 13.1046 30.8954 14 32 14C33.1046 14 34 13.1046 34 12C34 10.8954 33.1046 10 32 10ZM28 12C28 9.79086 29.7909 8 32 8C34.2091 8 36 9.79086 36 12C36 14.2091 34.2091 16 32 16C29.7909 16 28 14.2091 28 12Z"
        fill={color}
      />
    </svg>
  );
};

export default PathwayIcon;
